import { render } from "./nameLabel.vue?vue&type=template&id=5ffad27e&scoped=true"
import script from "./nameLabel.vue?vue&type=script&lang=js"
export * from "./nameLabel.vue?vue&type=script&lang=js"

import "./nameLabel.vue?vue&type=style&index=0&id=5ffad27e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ffad27e"]])

export default __exports__